export const HF_ACCESS_TOKEN = "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"; 
export const GOOGLE_API_KEY = "AIzaSyAbcmwnlTX5ivYIs5YA3lZb0ni9M6T4814"; 
export const REPLICATE_API_TOKEN = "r8_U2LfCTYqGxX7TevlSLerpnqa2gKIbJb2kwfXD"; 